module.exports = __webpack_public_path__ + "static/media/bars.66f745f3.svg";